const lodash = require('lodash');
const Logger = require('@KrashidBuilt/common/utils/logger');

const logger = new Logger('helpers/parser');

const GET = 'get';
const JOIN_OBJECT_FIELDS = 'join.object.fields';
const FIND_IN_ARRAY_OF_OBJECTS_USING_ID = 'find.in.array.of.objects.using.id';
const FIND_IN_ARRAY_OF_OBJECTS_USING_FILTER = 'find.in.array.of.objects.using.filter';
const FIND_IN_ARRAY_OF_OBJECTS_USING_ID_AND_OBJECT_ARRAY_FILTER = 'find.in.array.of.objects.using.id.and.object.array.filter';
const MORAWARE_FORM_FIELD_VALUE = 'moraware.form.field.value';
const FIND_NESTED_FIELD_VALUE_USING_FILTER = 'find.nested.field.value.using.filter';

const ACTIONS = {
    GET,
    JOIN_OBJECT_FIELDS,
    FIND_IN_ARRAY_OF_OBJECTS_USING_ID,
    FIND_IN_ARRAY_OF_OBJECTS_USING_FILTER,
    FIND_IN_ARRAY_OF_OBJECTS_USING_ID_AND_OBJECT_ARRAY_FILTER,
    MORAWARE_FORM_FIELD_VALUE,
    FIND_NESTED_FIELD_VALUE_USING_FILTER
};

const getValue = (job, query, filter) => {
    logger.extra({ job, query, filter });

    if (!job || !query) {
        return;
    }

    const {
        _, // the path to the object field that should be retrieved, searched or filtered
        idKey, // the key used when referencing an id within the object for search / filter
        idValue,
        valueKey,
        action,
        fields,
        delimiter,
        filterWithKey,
        filterOnKey,
        filterUsingKey,
        // FIND_NESTED_FIELD_VALUE_USING_FILTER
        fieldsName, // name of field you are search for in filtered object EX: area => customFields, activities => formFields
        fieldValueKey // the value to return in the field itself
    } = query;

    let found = false;

    switch (action) {
        // search response using object notion
        // EX query: { id: "account.name" }
        // EX data: { account: { name: "Bartholomew" } } 
        // get value => Bartholomew
        case GET:
            return lodash.get(job, _, '');

        // join object properties together given an array of fields (mainly used for addresses)
        // EX query: { fields : [zip, addressLine1, state, city] } 
        // EX data: "address": { "zip": "80501", "addressLine1": "1003 DEER POND CT", "state": "CO", city": "LONGMONT" }
        // join specified "fields" into "Job Address" => { type: 'txt', label: 'Job Address', value: '1003 DEER POND CT, LONGMONT, CO, 80501' }
        case JOIN_OBJECT_FIELDS:
            return fields.map((x) => lodash.get(lodash.get(job, _), x)).filter((x) => x).join(delimiter);

        // given an "idKey", "valueKey", "filter", and the "filterWithKey" (filter key type) find all objects in array where the filter matches
        // EX query: { 'idKey': 'id', 'valueKey': 'name', 'filterWithKey': 'phase' }
        // EX data: "jobPhases": [ { "name": "KIT SPLASH REBUILD", "id": 68579 }, { "name": "KIT SPLASH REBUOLD II", "id": 68793 } ]
        // map specified "valueKey" and their values into "Phase Id/Name" => [ { type: 'txt', label: 'Phase Id', value: 68793 }, { type: 'txt', label: 'Phase Name', value: 'KIT SPLASH REBUOLD II' } ]
        case FIND_IN_ARRAY_OF_OBJECTS_USING_FILTER:
            found = job[_].find((x) => String(lodash.get(x, idKey)) === String(filter[filterWithKey]));
            if (found) {
                return lodash.get(found, valueKey);
                // return found[valueKey];
            }
            return;

        case FIND_IN_ARRAY_OF_OBJECTS_USING_ID_AND_OBJECT_ARRAY_FILTER:
            found = job[_].find((x) => String(lodash.get(x, idKey)) === String(idValue) && (!filter[filterWithKey] || x[filterOnKey].find((xx) => String(xx[filterUsingKey]) === String(filter[filterWithKey]))));
            if (found) {
                return lodash.get(found, valueKey);
            }
            return;

        // in an array of objects, find the object that contains the given "idKey" property; which equals the given "idValue"
        // EX query: { idKey: id, idValue: 299, valueKey: 'value' }
        // EX data: customFields : [{ "name": "PC Email Address", "valueId": 681822, "id": 299, "value": "Panhneath.Ouk@frontrangestone.com", "dataType": "List of Values" }, { "name": "Project Coordinator", "valueId": 194587, "id": 33, "value": "Paneth (Ext 221)", "dataType": "List of Values" }]
        // iterate through objects for the matching case => { type: 'txt', label: '[Custom] - PC Email Address', value: 'Panhneath.Ouk@frontrangestone.com' }
        case FIND_IN_ARRAY_OF_OBJECTS_USING_ID:
            found = job[_].find((x) => String(lodash.get(x, idKey)) === String(idValue));
            if (found) {
                return lodash.get(found, valueKey);
                // return found[valueKey];
            }
            return;

        // get form field which match a given form filter and id
        // EX query: { "_": "forms", "action": "moraware.form.field.value", "idValue": 2254 }
        // EX data: "formTemplate": { "name": "BUILDER JOB INFO", "id": 23 }, "id": 1129047, "formFields": [ { "name": "Total $T", "id": 2113, "value": "4847", "dataType": "Number" }, { "name": "Builder PO#", "id": 2254, "dataType": "Text" } ], "jobPhases": []
        // match and map using filter and id => { type: 'text', label: '[Form] - Builder PO#', value: undefined }, { type: 'text', label: '[Form] - Total $T', value: '4847' }
        case MORAWARE_FORM_FIELD_VALUE:
            found = job[_].find((jf) => String(jf.id) === String(filter['form']));

            if (found) {
                return found.formFields.find((ff) => ff.id === idValue)?.value;
            }
            return;

        case FIND_NESTED_FIELD_VALUE_USING_FILTER:
            // iterate through key... which is an array of objects (EX: areas)
            found = job[_].find((ff) => // ff = filtered field
                // locate what object with filter matches the selected filter (find area that is selected by ui)
                String(ff[filterUsingKey]) === String(filter[filterWithKey]));

            if (found) {
                // if a filtered object (area) has been "found" (matches filter)
                // ...in that filtered object (area)... search through it's field(s) (an array of objects... EX: custom fields)
                // where the value of a field (f[valueKey]) matches template value (idValue)
                // get that fields value (fieldValue)
                return found[fieldsName].find((f) => f[valueKey] === idValue)[fieldValueKey];
            }
            return; // else - return nothing

        default:
            throw new Error(`Invalid action: "${action}"`);
    }
};

const getValues = (job, template, filter) => {
    logger.extra({ job, template, filter });

    if (!job || !template) {
        return [];
    }

    const fields = [];

    template.json_data.fields.forEach(({ type, label, query, id }) => {
        try {
            fields.push({ type, label, id, value: getValue(job, query, filter) });
        } catch (error) {
            logger.error('Unable to get value:', { type, label, id, query, error });
        }
    });

    return fields;
};
module.exports = {
    ACTIONS,
    getValue,
    getValues,
};